export default "__VITE_PUBLIC_ASSET__e652b353__"